import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Alert, Button, Col, Form, Row } from "react-bootstrap";
import { MdDelete, MdSave } from "react-icons/md";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl } from "../../../contexts/ContextProvider";
import { Loader, ScrollToTop } from "../../../components";
import { NumericFormat } from "react-number-format";

const TambahBarang = () => {
  const { user, dispatch } = useContext(AuthContext);
  const navigate = useNavigate();

  const [kode, setKode] = useState("");
  const [nama, setNama] = useState("");
  const [hargaJual, setHargaJual] = useState("");
  const [hargaPromo, setHargaPromo] = useState("0");
  const [stok, setStok] = useState("0");
  const [minimalQtyGrosir, setMinimalQtyGrosir] = useState("0");
  const [hargaGrosir, setHargaGrosir] = useState("0");
  const [isFlashsale, setIsFlashsale] = useState(false);
  const [deskripsi, setDeskripsi] = useState("");
  const [kategoris, setKategoris] = useState([]);
  const [kategoriId, setKategoriId] = useState("");
  const [merks, setMerks] = useState([]);
  const [merkId, setMerkId] = useState("");
  const [gambar, setGambar] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getKodeBarang = async () => {
      setLoading(true);
      try {
        const response = await axios.post(`${tempUrl}/getKodeBarang`, {
          _id: user.id,
          token: user.token,
        });
        setKode(response.data.kode);
      } catch (err) {
        if (err.response?.status === 401) {
          dispatch({ type: "LOGOUT" });
          navigate("/");
        }
        setError(err.response?.data?.message || "Gagal mengambil kode Barang.");
      }
      setLoading(false);
    };

    const getKategoris = async () => {
      try {
        const response = await axios.post(`${tempUrl}/kategoris`, {
          _id: user.id,
          token: user.token,
        });

        setKategoris(response.data);
      } catch (err) {
        if (err.response?.status === 401) {
          dispatch({ type: "LOGOUT" });
          navigate("/");
        }

        setError(
          err.response?.data?.message || "Gagal mengambil data kategori.",
        );
      }
    };

    const getMerks = async () => {
      try {
        const response = await axios.post(`${tempUrl}/merks`, {
          _id: user.id,
          token: user.token,
        });

        setMerks(response.data);
      } catch (err) {
        if (err.response?.status === 401) {
          dispatch({ type: "LOGOUT" });
          navigate("/");
        }

        setError(err.response?.data?.message || "Gagal mengambil data merk.");
      }
    };

    getKodeBarang();
    getKategoris();
    getMerks();
  }, [dispatch, navigate, user.id, user.token]);

  const fileToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () =>
        resolve({
          linkGambar: reader.result,
        });
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });

  const tambahGambar = async (event) => {
    const files = Array.from(event.target.files || []);
    const allowedFiles = files.filter((file) => file.type.startsWith("image/"));

    if (allowedFiles.length !== files.length) {
      setError("File foto harus berupa gambar.");
      event.target.value = "";
      return;
    }

    const gambarBaru = await Promise.all(allowedFiles.map(fileToBase64));
    setGambar((current) => [...current, ...gambarBaru]);
    event.target.value = "";
  };

  const hapusGambar = (index) => {
    setGambar((current) => current.filter((_, i) => i !== index));
  };

  const saveBarang = async (event) => {
    event.preventDefault();

    const hargaJualNumber = Number(hargaJual);
    const hargaPromoNumber = Number(hargaPromo || 0);
    const stokNumber = Number(stok || 0);
    const minimalQtyGrosirNumber = Number(minimalQtyGrosir || 0);
    const hargaGrosirNumber = Number(hargaGrosir || 0);

    if (!nama.trim()) {
      setError("Nama Barang wajib diisi.");
      return;
    }

    if (
      hargaJual === "" ||
      !Number.isFinite(hargaJualNumber) ||
      hargaJualNumber < 0
    ) {
      setError("Harga Jual tidak valid.");
      return;
    }

    if (!Number.isFinite(hargaPromoNumber) || hargaPromoNumber < 0) {
      setError("Harga Promo tidak valid.");
      return;
    }

    if (hargaPromoNumber > hargaJualNumber) {
      setError("Harga Promo tidak boleh lebih besar dari Harga Jual.");
      return;
    }

    if (!Number.isInteger(stokNumber) || stokNumber < 0) {
      setError("Stok tidak valid.");
      return;
    }

    if (!Number.isInteger(minimalQtyGrosirNumber) || minimalQtyGrosirNumber < 0) {
      setError("Minimal Qty Grosir tidak valid.");
      return;
    }

    if (!Number.isFinite(hargaGrosirNumber) || hargaGrosirNumber < 0) {
      setError("Harga Grosir tidak valid.");
      return;
    }

    if (!deskripsi.trim()) {
      setError("Deskripsi wajib diisi.");
      return;
    }

    if (!kategoriId) {
      setError("Kategori wajib dipilih.");
      return;
    }

    if (!merkId) {
      setError("Merk wajib dipilih.");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(`${tempUrl}/saveBarang`, {
        nama,
        hargaJual,
        hargaPromo: hargaPromo || 0,
        stok: stok || 0,
        minimalQtyGrosir: minimalQtyGrosir || 0,
        hargaGrosir: hargaGrosir || 0,
        isFlashsale,
        deskripsi,
        kategoriId,
        merkId,
        gambar,
        _id: user.id,
        token: user.token,
      });
      navigate(`/barang/${response.data.id}`);
    } catch (err) {
      if (err.response?.status === 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }
      setError(err.response?.data?.message || "Gagal menyimpan Barang.");
    }
    setLoading(false);
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div>
      <ScrollToTop />
      <div className="page-header">
        <div>
          <div className="page-kicker">Master</div>
          <h1 className="page-title">Tambah Barang</h1>
        </div>
      </div>
      <section className="section-panel">
        {error && <Alert variant="warning">{error}</Alert>}
        <Form onSubmit={saveBarang}>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Kategori</Form.Label>
                <Form.Select
                  value={kategoriId}
                  onChange={(event) => setKategoriId(event.target.value)}
                >
                  <option value="">Pilih Kategori</option>
                  {kategoris.map((kategori) => (
                    <option key={kategori.id} value={kategori.id}>
                      {kategori.kode} - {kategori.nama}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Merk</Form.Label>
                <Form.Select
                  value={merkId}
                  onChange={(event) => setMerkId(event.target.value)}
                >
                  <option value="">Pilih Merk</option>
                  {merks.map((merk) => (
                    <option key={merk.id} value={merk.id}>
                      {merk.kode} - {merk.nama}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Kode</Form.Label>
                <Form.Control value={kode} disabled />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Nama</Form.Label>
                <Form.Control
                  value={nama}
                  onChange={(e) => setNama(e.target.value)}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Deskripsi</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  value={deskripsi}
                  onChange={(event) => setDeskripsi(event.target.value)}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Harga Jual</Form.Label>
                <NumericFormat
                  value={hargaJual}
                  valueIsNumericString
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  allowNegative={false}
                  customInput={Form.Control}
                  onValueChange={(values) => {
                    setHargaJual(values.value);
                  }}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Check
                  type="checkbox"
                  label="Flash Sale"
                  checked={isFlashsale}
                  onChange={(event) => {
                    setIsFlashsale(event.target.checked);
                  }}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Harga Promo</Form.Label>
                <NumericFormat
                  value={hargaPromo}
                  valueIsNumericString
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  allowNegative={false}
                  customInput={Form.Control}
                  onValueChange={(values) => {
                    setHargaPromo(values.value);
                  }}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Stok</Form.Label>
                <NumericFormat
                  value={stok}
                  valueIsNumericString
                  decimalScale={0}
                  allowNegative={false}
                  customInput={Form.Control}
                  onValueChange={(values) => {
                    setStok(values.value);
                  }}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Minimal Qty Grosir</Form.Label>
                <NumericFormat
                  value={minimalQtyGrosir}
                  valueIsNumericString
                  decimalScale={0}
                  allowNegative={false}
                  customInput={Form.Control}
                  onValueChange={(values) => {
                    setMinimalQtyGrosir(values.value);
                  }}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Harga Grosir</Form.Label>
                <NumericFormat
                  value={hargaGrosir}
                  valueIsNumericString
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  allowNegative={false}
                  customInput={Form.Control}
                  onValueChange={(values) => {
                    setHargaGrosir(values.value);
                  }}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Foto Barang</Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*"
                  multiple
                  onChange={tambahGambar}
                />
                <div className="text-muted small mt-1">
                  Bisa pilih lebih dari satu foto. Penyimpanan sementara memakai
                  data URL di database.
                </div>
              </Form.Group>
              {gambar.length > 0 && (
                <div className="d-flex gap-2 flex-wrap mb-3">
                  {gambar.map((item, index) => (
                    <div
                      key={index}
                      className="border rounded p-2"
                      style={{ width: "120px" }}
                    >
                      <img
                        src={item.linkGambar}
                        alt={`Barang ${index + 1}`}
                        className="img-fluid rounded mb-2"
                        style={{ height: "80px", objectFit: "cover" }}
                      />
                      <Button
                        size="sm"
                        variant="outline-danger"
                        className="w-100 btn-icon"
                        type="button"
                        onClick={() => hapusGambar(index)}
                      >
                        <MdDelete /> Hapus
                      </Button>
                    </div>
                  ))}
                </div>
              )}
            </Col>
            <Col md={6}></Col>
          </Row>
          <div className="form-actions mt-3">
            <Button
              className="btn-back"
              type="button"
              variant="outline-secondary"
              onClick={() => navigate("/barang")}
            >
              {"< Kembali"}
            </Button>
            <Button className="btn-icon" type="submit">
              <MdSave /> Simpan
            </Button>
          </div>
        </Form>
      </section>
    </div>
  );
};

export default TambahBarang;
